module.exports = __webpack_public_path__ + "img/annotation.74b033ea.svg";